<script setup lang="ts">
import Modal from '@/components/elements/Modal.vue';

const { headingText, body, fast } = defineProps<{
  headingText: string;
  body: string;
  fast?: boolean;
}>();

import ProgressBar from './ProgressBar.vue';
</script>

<template>
  <Modal theme="base" size="narrow" :headingText hide-close>
    <template #body>
      <p>{{ body }}</p>
      <div class="progress-container">
        <ProgressBar :initialProgress="0" :maxProgress="95" :fast />
      </div>
    </template>
  </Modal>
</template>

<style scoped>
.progress-container {
  position: relative;
  margin-top: 2rem;
  height: 10px;
}
</style>
